export default class VoyageTweaksData {
    constructor(
        id,
        meshSpacingDistance,
        meshSpeedDistance,
        meshWidth,
        optimisationMode,
        solutionsLimit,
        reduceMeshToBaseRoute,
    ) {
        this.id = id;
        this.meshSpacingDistance = meshSpacingDistance;
        this.meshSpeedDistance = meshSpeedDistance;
        this.meshWidth = meshWidth;
        this.optimisationMode = optimisationMode;
        this.solutionsLimit = solutionsLimit;
        this.reduceMeshToBaseRoute = reduceMeshToBaseRoute;
    }
}